import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';

import { useAdmin } from './AdminContext';
import { adminApi, errorMessage } from './adminApi';

const MIN_LENGTH = 12;

// Primeiro acesso do admin (senha gerada pelo script): troca obrigatoria.
export default function AdminPasswordPage() {
  const { setAdmin } = useAdmin();
  const [values, setValues] = useState({ current: '', next: '', confirm: '' });
  const [busy, setBusy] = useState(false);

  const set = (key) => (event) => setValues((previous) => ({ ...previous, [key]: event.target.value }));
  const valid = values.current && values.next.length >= MIN_LENGTH && values.next === values.confirm;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    try {
      const { admin } = await adminApi.changePassword(values.current, values.next);
      toastr.success('Senha alterada.');
      setAdmin(admin);
    } catch (err) {
      toastr.error('Não foi possível alterar a senha.', errorMessage(err, 'Tente de novo em instantes.'));
      setBusy(false);
    }
  };

  return (
    <div className='gs-stack'>
      <header className='gs-page-header'>
        <span className='gs-eyebrow'>Primeiro acesso</span>
        <h1>Crie a sua senha do painel</h1>
        <p>A senha inicial é provisória. Escolha uma senha só sua, com ao menos {MIN_LENGTH} caracteres.</p>
      </header>
      <section className='pv-panel ad-narrow'>
        <form className='pv-form' onSubmit={handleSubmit}>
          <div className='pv-fields'>
            <label className='pv-field pv-field-wide'>
              <span>Senha atual (a provisória)</span>
              <input type='password' autoComplete='current-password' value={values.current} onChange={set('current')} />
            </label>
            <label className='pv-field'>
              <span>Senha nova</span>
              <input type='password' autoComplete='new-password' value={values.next} onChange={set('next')} />
            </label>
            <label className='pv-field'>
              <span>Repita a senha nova</span>
              <input type='password' autoComplete='new-password' value={values.confirm} onChange={set('confirm')} />
            </label>
          </div>
          {values.confirm && values.confirm !== values.next && <p className='pv-panel-hint ad-error'>As senhas não são iguais.</p>}
          <div className='pv-panel-actions'>
            <button type='submit' className='gs-btn gs-btn-primary' disabled={!valid || busy}>{busy ? 'Salvando…' : 'Salvar senha'}</button>
          </div>
        </form>
      </section>
    </div>
  );
}
